import userRoutes from '@mv-submodules/inplant-user-fe/ui/routes'
import { routes as checklistRoutes } from '@mv-submodules/inplant-checklist-fe-iblu/index'
import { routes as mcsRoutes } from '@mv-submodules/inplant-mcs-fe-iblu/index'
import { generateRoutes } from '@mv-submodules/inplant-chronoframe-fe/ui/routes'
import { routes as plantHaltsRoutes } from '@mv-submodules/inplant-fermiimpianto-fe-iblu/index'
import PlantHaltListRicSg from '@mv-submodules/inplant-fermiimpianto-fe-iblu/ui/components/views/PlantHaltList/ricSg/PlantHaltListRicSgPageView'
import { routes as titechRoutes } from '@mv-submodules/inplant-titech-fe-iblu'
import { recipeRoutes } from '@mv-submodules/vidim-recipecontrol-fe'
import attachInplantWrapperTo from '../../inplant-coreadapter-fe/ui/components/widgets/InplantWrapper/InplantWrapperHOC'
import { RoutePropsCoreWithLegacy, RoutePropsLegacy } from '../../inplant-coreadapter-fe/types/routes'
import { mapRoutePropsLegacyToRoutePropsCoreWithLegacy } from '../../inplant-coreadapter-fe/functions/routeAdapter'
import { proximityRoutes } from '../../vidim-proximity-fe/index'
import { routes as assetManagerRoutes } from '../../inplant-asset-manager-fe'

const userCan = (roles: string[] | boolean, userRoles: string[]) => {
  if (typeof roles === 'boolean') {
    return roles
  }
  return userRoles.filter(value => -1 !== roles.indexOf(value)).length > 0
}

const userCant = (roles: string[] | boolean, userRoles: string[]) => !userCan(roles, userRoles)

const applyESTSELVisibility = (route: RoutePropsLegacy, userRoles: string[]) => {
  const path = route.path || ''
  const pathsToRestrict = [
    '/titech',
    '/asset-manager',
    '/plant-halts',
    '/anomalie',
    '/scadenziario',
    '/proximity',
    '/plant-control/',
    '/u2-phase2-control',
    '/press223-control',
  ]

  const needsRestriction = pathsToRestrict.some(p => path.startsWith(p))

  if (needsRestriction) {
    const isVisible = route.visible === undefined ? true : route.visible
    route.visible = isVisible && userCant(['ESTSEL'], userRoles)
  }
}

const composeRoutes = (moduleRoutes: RoutePropsLegacy[], userRoles: string[]) => {
  return moduleRoutes.map(routeGroup => {
    const aclRoute = routeGroup

    // * -------------------------------- MODULE --------------------------------
    switch (routeGroup.path) {
      // * CHECKLIST
      case '/checklist/models-assets':
        aclRoute.visible = userCan(true, userRoles)
        break

      // * MCS
      case '/mcs/today':
        aclRoute.visible = userCan(
          ['RSACP', 'SACP', 'RCP', 'DID', 'REA', 'RSPP', 'ASPP', 'CI', 'ASQ', 'UTM', 'RMAG', 'SVA', 'ESTMAG'],
          userRoles
        )
        break

      // * SCADENZARIO
      case '/scadenziario/ongoing':
        aclRoute.visible = userCant(['EST', 'ESTMAN', 'ESTMAG', 'PRE', 'SEL', 'ALI'], userRoles)
        break

      // * TITECH
      case '/titech':
        aclRoute.visible = userCant(['EST', 'ESTMAN', 'ESTMAG', 'PRE', 'SEL', 'ALI'], userRoles)
        break

      // * PLANT CONTROL
      case '/plant-control/day-summary':
        aclRoute.visible = userCant(['ESTMAG', 'ESTMAN', 'PRE', 'SEL', 'ALI'], userRoles)
        break

      // * TITECH CONTROL
      case '/titech-control/daily-management':
        aclRoute.visible = userCant(['ESTMAG', 'ESTMAN', 'PRE', 'SEL', 'ALI'], userRoles)
        break

      // * PROXIMITY
      case '/proximity/activity':
        aclRoute.visible = userCant(['ESTSEL'], userRoles)
        break

      case '/proximity/beacon-list':
        aclRoute.visible = userCant(['ESTMAN', 'PRE', 'SEL', 'ALI', 'ESTSEL'], userRoles)
        break

      case '/proximity/groups':
        aclRoute.visible = userCant(['ESTSEL'], userRoles)
        break

      // * FERMI
      case '/plant-halts/unchecked':
        aclRoute.visible = userCant(['EST', 'ESTMAN', 'ESTMAG', 'PRE', 'SEL', 'ALI'], userRoles)
        break
      case 'http://sg.inplant.hubme.in/manutenzioni-beni/da-fare/':
        aclRoute.visible = userCan(
          ['RSACP', 'SACP', 'RCP', 'DID', 'REA', 'RSPP', 'ASPP', 'CI', 'ASQ', 'UTM', 'RMAN', 'MAN'],
          userRoles
        )
        break

      // * ANOMALIE
      case '/anomalie/anomalie-ongoing':
        aclRoute.visible = userCant(['EST', 'ESTMAG'], userRoles)
        break
    }

    applyESTSELVisibility(aclRoute, userRoles)

    // root's childs visibility, should include all child acls
    // * -------------------------------- MODULE SECTION --------------------------------
    if (routeGroup.children) {
      aclRoute.children = routeGroup.children.map((childRoute: RoutePropsLegacy) => {
        switch (childRoute.path) {
          // * CHECKLIST
          case '/checklist/models-assets':
            childRoute.visible = userCan(true, userRoles)
            break

          case '/checklist/models':
            childRoute.visible = userCan(true, userRoles)
            break

          case '/checklist/archive':
            childRoute.visible = userCan(
              [
                'RCP',
                'RPROD',
                'VRPROD',
                'RMAG',
                'DID',
                'REA',
                'RSPP',
                'ASPP',
                'CI',
                'ASQ',
                'RSACP',
                'UTM',
                'RMAN',
                'SACP',
                'CSS',
                'SVA',
                'PRE',
                'SEL',
                'ALI',
              ],
              userRoles
            )
            break

          case '/checklist/today-summary':
            childRoute.visible = userCant(['ESTSEL'], userRoles)
            break

          case '/checklist/day-summary':
            childRoute.visible = userCant(['ESTSEL'], userRoles)
            break

          case '/checklist/photos':
            childRoute.visible = userCant(['ESTSEL'], userRoles)
            break

          case '/checklist/setup':
            childRoute.visible = userCan(['SVA', 'UTM'], userRoles)
            break

          case '/checklist/personal-archive':
            childRoute.visible = userCan(
              [
                'RCP',
                'RPROD',
                'VRPROD',
                'RMAG',
                'DID',
                'REA',
                'RSPP',
                'ASPP',
                'CI',
                'ASQ',
                'RSACP',
                'UTM',
                'RMAN',
                'SACP',
                'CSS',
                'PRE',
                'SEL',
                'ALI',
              ],
              userRoles
            )
            break

          case '/checklist/validations':
            childRoute.visible = userCan(
              [
                'RCP',
                'RPROD',
                'VRPROD',
                'MAG',
                'RMAG',
                'ASPP',
                'ASQ',
                'RMAN',
                'EST',
                'DL LOGISTICA',
                'ESTSEL',
                'DL ADDETTI U2',
                'IBLU U1',
                'IBLU U2',
                'RMAN',
                'MAN',
                'RPROD',
                'RCP',
                'CSS',
                'ESTMAN',
              ],
              userRoles
            )
            break

          case '/checklist/reset-asset-hours':
            childRoute.visible = userCan(['RSACP', 'SACP', 'RCP', 'UTM', 'PRE', 'SEL', 'ALI'], userRoles)
            break

          case '/checklist/gia':
            childRoute.visible = userCan(
              ['RMAG', 'RPROD', 'VRPROD', 'SACP', 'RSACP', 'DID', 'REA', 'MAG', 'SVA'],
              userRoles
            )
            break

          // * MCS
          case '/mcs/today':
            childRoute.visible = userCan(
              ['RSACP', 'SACP', 'RCP', 'DID', 'REA', 'RSPP', 'ASPP', 'CI', 'ASQ', 'UTM', 'RMAG', 'SVA', 'ESTMAG'],
              userRoles
            )
            break

          // * SCADENZARIO

          case '/scadenziario/manager':
            childRoute.visible = userCan(['RQ', 'RA', 'ASPP', 'RSCOMM', 'SCOMM', 'SVA'], userRoles)
            break

          // * RECIPE
          case '/recipe-control/planner':
            childRoute.visible = userCan(['RPROD', 'RCP'], userRoles)
            break

          // * TITECH RECIPE
          case '/titech-control/configuration':
            childRoute.visible = userCan(['UTM', 'RPROD', 'RCP'], userRoles)
            break
          case '/titech-control/planner':
            childRoute.visible = userCan(['RCP', 'RSACP', 'SACP', 'RPROD', 'UTM'], userRoles)
            break
          case '/titech-control/summary':
            childRoute.visible = userCan(['RPROD', 'VRPROD', 'UTM'], userRoles)
            break
          case '/titech-control/currentDay':
            childRoute.visible = userCan(['RPROD', 'VRPROD', 'UTM'], userRoles)
            break
          case '/titech-control/attuative':
            childRoute.visible = userCan(['RCP', 'RSACP', 'SACP', 'RPROD', 'VRPROD', 'UTM'], userRoles)
            break
          case '/titech-control/daily-management':
            childRoute.visible = userCant(['ESTMAG', 'PRE', 'SEL', 'ALI'], userRoles)
            break
          case '/titech/setup':
            childRoute.visible = userCant(['VRPROD', 'RPROD'], userRoles)
            break

          // * PRESS223 RECIPE
          case '/press223-control/planner':
            childRoute.visible = userCan(['RPROD', 'RCP', 'UTM'], userRoles)
            break

          // * RECIPE PHASE 2
          case '/u2-phase2-control/planner':
            childRoute.visible = userCan(['RPROD', 'RCP'], userRoles)
            break
        }
        applyESTSELVisibility(childRoute, userRoles)
        return childRoute
      })
    }
    return aclRoute
  })
}

export const aclRoutes = (sroutes: RoutePropsCoreWithLegacy[], forbiddenActions: string[], loginSuccessPath: string) =>
  sroutes.filter(r => r)

export const aclRedirect = (loginSuccessPath: string) => loginSuccessPath

// Sezione "Fermi impianto" del modulo, con in piu' la pagina dedicata a San Giorgio Bluair
// ("Elenco fermi U2": zone ristrette alle 5 linee, righe colorate e totali per linea).
// Affianca la pagina classica, non la sostituisce.
// Stessa visibilita' di "Elenco fermi": vale la regola sulla sezione (case '/plant-halts/unchecked')
// e, siccome il path inizia con `/plant-halts`, la restrizione ESTSEL di applyESTSELVisibility.
const plantHaltsWithRicSgRoutes: RoutePropsLegacy = {
  ...plantHaltsRoutes,
  children: [
    ...(plantHaltsRoutes.children || []),
    {
      path: '/plant-halts-ric-sg',
      exact: true,
      i18nkey: 'plantHalts.navigation.plantHaltsRicSg',
      visible: true,
      component: PlantHaltListRicSg,
    },
  ],
}

const routes: (userRoles: string[]) => RoutePropsCoreWithLegacy[] = userRoles => {
  const result = [
    ...composeRoutes(
      [
        ...recipeRoutes,
        attachInplantWrapperTo(checklistRoutes),
        attachInplantWrapperTo(mcsRoutes),
        attachInplantWrapperTo(
          generateRoutes('scadenziario', ['ongoing', 'overdue', 'user-tasks', 'to-validate', 'archive', 'rejected'])
        ),
        attachInplantWrapperTo(
          generateRoutes('anomalie', ['anomalie-ongoing', 'anomalie-overdue', 'anomalie-archive', 'anomalie-rejected'])
        ),
        attachInplantWrapperTo(plantHaltsWithRicSgRoutes),
        attachInplantWrapperTo(userRoutes),
        attachInplantWrapperTo(titechRoutes),
        attachInplantWrapperTo(assetManagerRoutes),
        proximityRoutes,
      ],
      userRoles
    ).map(mapRoutePropsLegacyToRoutePropsCoreWithLegacy),
  ]
  return result
}

export default routes
